const autoNgTemplateLoaderTemplate1 = require('./wizard-tls.html');

import angular from 'angular';

angular.module('shbdeployer.app').component('wizardTls', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  bindings: {
    formData: '<',
    onChange: '<',
  },
});
